// @ts-nocheck
// Polyfill for `findNodeHandle` on React Native Web
// --------------------------------------------------
// RNW 0.19+ deliberately throws when `findNodeHandle` is used, pushing people
// toward refs.  Gluestack's AlertDialog (RN-Aria) still calls it to move focus,
// which now crashes the web build:
//   Error: findNodeHandle is not supported on web.
//
// We patch the exported function at runtime (web-only) with a minimal shim that
// returns the underlying DOM element.  Implementation strategy:
// 1. If input is already a DOM element, return it.
// 2. If input is a React ref object, return ref.current.
// 3. Fallback to `ReactDOM.findDOMNode` (polyfilled earlier) for class/
//    composite components.
// --------------------------------------------------

import * as ReactNative from 'react-native';
import * as ReactDOM from 'react-dom';

const { Platform } = ReactNative;

if (Platform.OS === 'web') {
  const polyfill = (componentOrElement: any): Element | null => {
    if (!componentOrElement) return null;

    if (componentOrElement instanceof Element) return componentOrElement;

    // React ref object { current: ... }
    if (
      typeof componentOrElement === 'object'
      && 'current' in componentOrElement
      && componentOrElement.current instanceof Element
    ) {
      return componentOrElement.current;
    }

    // Fall back to ReactDOM.findDOMNode (already shimmed).
    // @ts-ignore
    if (typeof ReactDOM.findDOMNode === 'function') {
      // @ts-ignore
      return ReactDOM.findDOMNode(componentOrElement);
    }

    return null;
  };

  // Override the exported function
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ReactNative.findNodeHandle = polyfill;
  } catch (e) {
    // Property might be read-only in newer RN versions
    try {
      Object.defineProperty(ReactNative, 'findNodeHandle', {
        value: polyfill,
        configurable: true,
        writable: true,
      });
    } catch (e2) {
      // Completely frozen
    }
  }

  // Patch RNW export module so future imports get the polyfilled version
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const rnwModule = require('react-native-web/dist/exports/findNodeHandle');
    if (rnwModule && rnwModule.default && rnwModule.default !== polyfill) {
      try {
        rnwModule.default = polyfill;
      } catch (e) {
        // Handle read-only default export
        try {
          Object.defineProperty(rnwModule, 'default', {
            value: polyfill,
            configurable: true,
            writable: true,
          });
        } catch (e2) {
          // Completely frozen
        }
      }
    }
  } catch {}
}
